module.exports = __webpack_public_path__ + "static/media/imgHome.350149f9.png";